export default function ({ store, redirect, localePath, route }) {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  if (!isAuthenticated) {
    return redirect(
      localePath({
        path: "/sign-in",
        query: {
          redirect: route.fullPath,
        },
      })
    );
  }
}
